import { activeComponentKey } from "@/config/constants/StorageKeys";
import { getData, saveData } from "@/utils/localStorage";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ComponentType =
  | "Exchange"
  | "Transactions"
  | "POS Clients"
  | "Settings"
  | "Inbox"
  | "Dashboard"
  | "Status"
  | "Clude"
  | "Reports"
  | "Clients"
  | "Groups"
  | "Logs";

export interface ComponentState {
  activeComponent: ComponentType;
  activeTab: number
}

const initialState: ComponentState = {
  activeComponent: getData<ComponentType>(activeComponentKey) ?? "Dashboard",
  activeTab: 0
};

const componentSlice = createSlice({
  name: "component",
  initialState,
  reducers: {
    setActiveComponent: (state, action: PayloadAction<ComponentType>) => {
      state.activeComponent = action.payload;
      saveData(activeComponentKey, action.payload)  
    },
    setActiveTab: (state, action: PayloadAction<number>) => {
        const tab = action.payload

        if(tab < 0 || tab > 3) {
            state.activeTab = 0
            return
        }

        state.activeTab = tab

    }
  },
});

export const { setActiveComponent, setActiveTab } = componentSlice.actions;

export default componentSlice;
